export const APP_NAME = 'KeLike';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ONBOARDING: '/onboarding',
  PROFILE: '/@:username',
  SETTINGS: '/settings',
  SEARCH: '/search',
  BOOKMARKS: '/bookmarks',
  NOTIFICATIONS: '/notifications',
  MESSAGES: '/messages',
  POST: '/post/:id',
} as const;

export const STORAGE_BUCKETS = {
  AVATARS: 'avatars',
  COVERS: 'covers',
  POST_MEDIA: 'post-media',
  MESSAGE_MEDIA: 'message-media',
} as const;

export const LIMITS = {
  MAX_POST_CONTENT_LENGTH: 280,
  MAX_BIO_LENGTH: 160,
  MAX_COMMENT_LENGTH: 280,
  MAX_FILE_SIZE_MB: 10,
  MAX_POST_IMAGES: 4,
  POSTS_PER_PAGE: 20,
  COMMENTS_PER_PAGE: 20,
  MESSAGES_PER_PAGE: 50,
} as const;

export const NOTIFICATION_TYPES = {
  LIKE: 'like',
  COMMENT: 'comment',
  REPLY: 'reply',
  REPOST: 'repost',
  FOLLOW: 'follow',
  MESSAGE: 'message',
} as const;
